<template>
    <div v-if="showBanner" class="full-screen"  @click="closeBanner">
        <button class="close-button">×</button>
        <img src="@/assets/img/banner-popup-aviso-fraude.webp" alt="Banner Inauguração">
    </div>
</template>

<script>
export default {
    data() {
        return {
            //Meses no Js vão de 0 a 11
            //Ou seja, para 31/05 tive que colocar 4, 31
            //APENAS ESSE PARAMETRO ABAIXO E A IMAGEM DEVEM SER ALTERADOS
            //CASO CONTRARIO RISCO DE BUGS!!!!!!!!!!!!!
            finalDate: new Date(2025, 4, 31, 23, 59),
            showBanner: true
        };
    },
    methods: {
        closeBanner() {
            this.showBanner = false;
            const currentDate = new Date();
            const diffTime = this.finalDate.getTime() - currentDate.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            console.log(diffDays)
            const expiresInDays = diffDays > 0 ? diffDays : 1;
            this.setCookie('bannerClosed', 'true', expiresInDays);
        },
        checkDate() {
            if(this.lang !== 'ptBR' ){
                this.showBanner = false;
                return
            }

            const now = new Date();
            const bannerClosed = this.getCookie('bannerClosed');

            if (now > this.finalDate || bannerClosed === 'true') {
                this.showBanner = false;
            }
        },
        setCookie(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
        },
        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }
    },
    mounted() {
        this.checkDate();
    }
};
</script>


<style scoped>
.full-screen {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000000b8;
    z-index: 10000000000000;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 15px;
    background: transparent;
    border: none;
    font-size: 2rem;
    color: white;
    cursor: pointer;
}

/* Estilo opcional para a imagem */
.full-screen img {
    max-width: 90%;
    max-height: 90%;
}
</style>
